import React from 'react';
import SectionMessage from '@atlaskit/section-message';

import { PreviewWarningSectionWrapper as Wrapper } from '../styles';

const SECTION_TITLE = 'It\'s only a preview';

const renderWarningMessage = () => (
    <p>
        Below you can see the dialogue that the user fills in when editing this field. Remember, here <strong>we display the saved configuration</strong>.
        If you&apos;ve made any changes and you don&apos;t see them here, most likely you haven&apos;t saved them.
    </p>
);

const PreviewWarningSection: React.FC = () => (
    <Wrapper>
        <SectionMessage title={SECTION_TITLE} appearance="warning">
            {renderWarningMessage()}
        </SectionMessage>
    </Wrapper>
);

export default PreviewWarningSection;
